export default "<h3>Gateway Rate Limiting Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"